import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RequireAdmin({ children }) {
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  if (!isAdmin) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Not Authorized</h1>
          <p className="auth-subtitle">
            {user.email} does not have admin access. Ask an existing admin to grant it from the Users page.
          </p>
          <button className="btn btn-outline btn-full" onClick={logout}>Sign out</button>
        </div>
      </div>
    );
  }

  return children;
}
